const LANGUAGES = {
  CURRENT_APP_LANGUAGE: 'APP_LANGUAGE',
  ENGLISH: 'en',
  AVAILABLE_LANGUAGES: [
    {
      label: 'EN',
      code: 'en',
    },
    {
      label: 'FR',
      code: 'fr',
    },
  ],
};

export default LANGUAGES;
